import queryString from 'query-string';
import { request, toSnakeCase } from '../../shared/request';

const baseName = () => (window.currentLocale.basename || '');

export const loadWorksApi = (page, activeFilters) => {
  const params = { page };
  Object.keys(activeFilters).forEach((f) => {
    params[f] = activeFilters[f].value;
  });
  return request(`${ baseName() }/stylist/works?per=40&${ queryString.stringify(params) }`);
};

export const loadWorkDetailsApi = (id) => request(`${ baseName() }/api/arts/${ id }`);

export const loadArtfilters = () => request(`${ baseName() }/api/arts/filters`);

export const signWallUpload = (wallId, contentType, prefix, name, extension) => request(
  `${ baseName() }/stylist/wall_builder/sign?wall_id=${ wallId }`, {
    method: 'POST',
    body: JSON.stringify({
      content_type: contentType, prefix, name, extension
    })
  }
);

export const saveWallApi = ({
  wallId, ...rest
}) => {
  const body = toSnakeCase(rest);
  return request(
    `${ baseName() }/stylist/wall_builder?id=${ wallId }`,
    {
      method: 'PUT',
      body: JSON.stringify(body)
    }
  );
};

export const publishWallApi = (wallId) => request(
  `${ baseName() }/stylist/wall_builder/publish?id=${ wallId }`,
  {
    method: 'POST'
  }
);

export const loadSmilarWorks = (id) => request(`${ baseName() }/stylist/works?similar_of=${ id }&per=40&page=0`);

export const loadHanging = (id) => request(`${ baseName() }/stylist/walls/${ id }?marks=true`);

export const saveHangingAll = (wallId, hangingMarks, image) => {
  const body = toSnakeCase({ wall: { hangingMarks }, image });
  return request(
    `${ baseName() }/stylist/walls/${ wallId }/hanging`,
    {
      method: 'POST',
      body: JSON.stringify(body)
    }
  );
};

export const saveHangingImage = (wallId, image) => request(
  `${ baseName() }/stylist/walls/${ wallId }/hanging`,
  {
    method: 'POST',
    body: JSON.stringify({
      image
    })
  }
);

export const loadFavoriteWallsApi = () => request(`${ baseName() }/stylist/wall_builder/favorite_walls`);

export const importWallApi = (wallId, sourceWallId) => request(
  `${ baseName() }/stylist/wall_builder/import_wall?id=${ wallId }`,
  {
    method: 'POST',
    body: JSON.stringify({ source_wall_id: sourceWallId })
  }
);
